console.log("running script for recommendation");

// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let market = null;
let locale = null;

const default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "BUY NOW"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Add default image url here
const tangent_default_selfie_image_url="";

const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

if(document.getElementById("seo-content")){
  document.getElementById("seo-content").style.display = 'none';
}
if(document.getElementById("tangent_recommendation")){
  document.getElementById("tangent_recommendation").style.display = 'block';
}

window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  let resp_id = tangent_client_url.searchParams.get("resp_id");
  if(!resp_id){
    resp_id = document.getElementById("tangent-resp-id")?.value;
  }
  return resp_id;
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    
    if(document.getElementById("seo-content")){
      document.getElementById("seo-content").style.display = 'none';
    }
    
    if(document.getElementById("tangent_recommendation")){
      document.getElementById("tangent_recommendation").style.display = 'block';
    }
    
    market = document.getElementById("tangent-shop-market").value;
    locale = document.getElementById("tangent-shop-locale").value;
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true&market="+market;
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  } else {
    document.getElementById("seo-content").style.display = 'block';
    document.getElementById("tangent_recommendation").style.display = 'none';
  }
}

function checkoutDataProcess(response){
    let tangent_recommended_products = response.products;

    let tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    let tangent_product_sections = response.product_sections;
    let tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        let work_with_professional_status = false;
        tangent_selected_product_map = {};
        // DISABLE PRICE AND ADD TO CART FOR PRO PAGES
        if(response.tags.includes("work_with_professional")){
          work_with_professional_status = true;
          product_add_to_cart_button_HTML='';
          product_pricing_HTML='';
        }
      
        populateProductSections(tangent_recommended_products, tangent_product_sections, work_with_professional_status, tangent_client_domain_currency);
        enableButtonListener(response);
        loadElementsOnResponseData(response);   

        disableElementsForMarket(market);
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }
}

function disableElementsForMarket(market) {
  if (market === 'CA') {
    document.querySelectorAll('.cad-hide').forEach(element => {
      element.style.display = "none";
    });
  }
}

function populateProductSections(tangent_recommended_products, tangent_product_sections, work_with_professional_status, tangent_client_domain_currency){
    for (const section in tangent_product_sections) {
      const productIds = tangent_product_sections[section];
      const sectionProductGrid = document.getElementById(`${section}_product_grid`);
      let sectionHTML = ''; // Initialize an empty string to accumulate the HTML for the section
  
      productIds.forEach(pid => {
        tangent_recommended_products.forEach((product, index) => {
          if (String(product.id) === pid && product.publishedInContext) {
            let selectedVariant = product.variants.edges[0].node;
            let productAvailable = isProductAvailable(product, selectedVariant);
            let addToCartText = productAvailable ? default_addToCartText : out_of_stock_text;
            let disabledClassList = productAvailable ? "": "disable-btn-wrapper";
            // Map selected product ID for quick lookup
            tangent_selected_product_map[product.id] = Number(
              selectedVariant.id.replace("gid://shopify/ProductVariant/", "")
            );
            if(productAvailable){
              updateSectionAllToCartLink(tangent_product_sections,section,product.id);
            }
            // Set default currency and price
            let variantPrice = getVariantPriceInNumber(selectedVariant);
            let productPrice = getCurrencyFormattedPrice(selectedVariant, variantPrice);

            // Conditionally generate Add to Cart and Pricing HTML
            const addToCartButtonHTML = work_with_professional_status ? '' : generateAddToCartButtonHTML(tangent_selected_product_map[product.id], section, index, addToCartText, disabledClassList);
            const pricingHTML = work_with_professional_status ? '' : generatePricingHTML(productPrice, index);
  
            // Generate and append product HTML
            sectionHTML += generateProductHTML(product, selectedVariant, section, index, addToCartButtonHTML, pricingHTML);
          }
        });
      });

      // Update section grid with accumulated HTML
      sectionProductGrid.innerHTML = sectionHTML;
    }
}

// Helper function to check product availability
function isProductAvailable(product, variant) {
  return product.status === "ACTIVE" && (
    variant.inventoryPolicy !== "deny" || variant.inventoryQuantity >= 1
  );
}

const getCurrencyFormattedPrice = (variant, price) => {
    return getVariantCurrencySymbol(variant) + price;
}

const getVariantPriceInNumber = (variant) => {
    let price_string = null;
    if(market == 'us'){
        price_string = variant.price;
    } else {
        price_string = variant.contextualPricing.price.amount;
    }
    return Number(price_string.replace(/[^0-9.-]+/g, ""));
}

const getVariantCurrencySymbol = (variant) => {
    if(market == 'us' || market == 'au'){
        return "$";
    } else {
        const currency = variant.contextualPricing.price.currencyCode;
        let price_currency = new Intl.NumberFormat(locale, {style: 'currency', currency:currency,}).formatToParts("1").find(part=>part.type="currency").value
        if(price_currency == "CA$"){
          price_currency ="$"; 
        }
        return price_currency;            
    }
}

// Function to generate Add to Cart button HTML
function generateAddToCartButtonHTML(variantId, section, index, addToCartText, disabledClassList) {
  return `
    <a class="tangent-product-add-btn-wrapper ${disabledClassList}" id="${variantId}" href="javascript: void(0)">
      <button class="tangent-btn-add tangent_add_to_cart_button ${disabledClassList}" id="${section}_cart_tangent_product_${index}_text">
        ${addToCartText}
      </button>
    </a>
  `;
}

// Function to generate Pricing HTML
function generatePricingHTML(price, index) {
  return `<p id="price_tangent_product_${index}" class="tangent_product_price_text">${price}</p>`;
}

// Function to generate the full HTML for a product card
function generateProductHTML(product, variant, section, index, addToCartButtonHTML, pricingHTML) {
  const variantImageUrl = variant.image ? variant.image.url : product.images.nodes[0].url;
  const productUrl = `${tangent_client_domain_url}/products/${product.handle}?variant=${tangent_selected_product_map[product.id]}`;
  
  return `
    <div>
      <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${productUrl}">
        <img id="image_tangent_product_${index}" src="${variantImageUrl}" class="tangent_product_image" alt="${product.title}">
        <p class="tangent-product-title tangent_product_title_text">
          <b>${product.title}</b>
        </p>
        ${pricingHTML}
      </a>
      <div id="${section}_variant_${index}"></div>
    </div>
  `;
  
      // ${addToCartButtonHTML}
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, section,product_id){
  // Create and add all sections cart values to a map
  let variant_id = tangent_selected_product_map[product_id];
  if (product_sections[section].includes(String(product_id))) {
      if(sections_add_to_cart_map[section]){
          if(!sections_add_to_cart_map[section].list.includes(variant_id)){
            sections_add_to_cart_map[section].count++;
            sections_add_to_cart_map[section].cart_link =  sections_add_to_cart_map[section].cart_link+ "&id[]=" + variant_id;
            sections_add_to_cart_map[section].list.push(variant_id);

            // Enable / disable add all to cart based on products count
            document.getElementById(section+"_add_all_to_cart").style.display="block";
          }
      }
      else{
          sections_add_to_cart_map[section] = {
              count:1,
              cart_link: tangent_client_domain_url + "/cart/add?id[]="+variant_id,
              list:[variant_id]
          }
      }
      document.getElementById(section+"_add_all_cart_link").href = sections_add_to_cart_map[section].cart_link;
  }                                
}

// Add all to cart function for sections
function addAllTocartFunction(section) {  
    if(sections_add_to_cart_map[section]!=undefined){
        document.getElementById(section+"_add_all_cart_link").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

function createFormDataFromIds(idArray) {
  return {
    items: idArray.map(id => ({
      id: id,
      quantity: 1
    }))
  };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id]);
  addToCartApi(formData, element);
}

function addToCartApi(payload, element){
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    onSuccessChange(element);
  }).catch((error) => {
      console.error('Error:', error);
  });
}

function onSuccessChange(element){
  element.innerHTML = default_addedToCartText;
  element.classList.add("added-to-cart-style"); 
  const cartLink = document.querySelector('a[href="/cart"][aria-controls="cart-drawer"]');
  if (cartLink) {
    cartLink.click();
  }
  document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
  document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
  })); 
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    // section_container.classList.add("tabcontent");
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    var add_all_to_cart_p_tag = document.createElement("button");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");
    add_all_to_cart_p_tag.innerHTML = default_add_all_to_cart_text;

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";

    // Enabling listener
    add_all_cart_link.addEventListener(
        'click',
        function () { addAllTocartFunction(section_name); },
        false
    );
  
    add_all_cart_link.appendChild(add_all_to_cart_p_tag);
    // add_all_to_cart_p_tag.appendChild(add_all_cart_link);
    return add_all_cart_link;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

function setSelfieContainerView(display_style){
  document.getElementById("tangent_selfie_container").style.display=display_style;
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_selfie.appendChild(section_container);
            }
            else if(section_name=="section_additional_selfie"){
              var section_additional_selfie = document.querySelector("#section_additional_selfie_container_parent");
              section_container.classList.remove('tabcontent');   
              section_additional_selfie.appendChild(section_container);
            }
            else if(section_name=="section_apply_formula_basics"){
              var section_basic_container = document.querySelector("#section_basic_container");
              section_container.classList.remove('tabcontent');   
              section_basic_container.appendChild(section_container); 
            } 
            else if(section_name=="section_apply_formula_skinentials"){
              var section_skinentials_container = document.querySelector("#section_skinentials_container");
              section_container.classList.remove('tabcontent');   
              section_skinentials_container.appendChild(section_container); 
            }
            else if(section_name=="section_apply_formula_supercharged"){
              var section_supercharged_container = document.querySelector("#section_supercharged_container");
              section_container.classList.remove('tabcontent');   
              section_supercharged_container.appendChild(section_container); 
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
    setSelfieContainerView("flex");
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
            }
        }
    }
}

// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function loadElementsOnResponseData(response){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
  var recommendationproducts_title = document.getElementById("section_recommendation_text_container");
  if(sections_add_to_cart_map['section_recommendation']==undefined && response.tags.includes("shop_my_protocol")){
    recommendationproducts_title.style.display="none";
  }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}